/* Herbal Vitaly — Shopify Markets localization + GeoIP country selection. */
(function () {
  'use strict';

  var MANUAL_KEY = 'hv-country-manual-v1';
  var AUTO_KEY = 'hv-country-geoip-v1';
  var RESTORE_KEY = 'hv-country-restore-v1';

  function normalizeCountry(value) {
    return String(value || '').trim().toUpperCase();
  }

  function safeGet(storage, key) {
    try { return storage.getItem(key); } catch (error) { return null; }
  }

  function safeSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (error) {}
  }

  function matchingCountryOption(select, code) {
    var normalized = normalizeCountry(code);
    if (!select) return null;
    return Array.prototype.find.call(select.options, function (option) {
      return normalizeCountry(option.value) === normalized;
    }) || null;
  }

  function countrySelectFor(code) {
    var selects = Array.prototype.slice.call(document.querySelectorAll('[data-country-selector]'));
    return selects.find(function (select) {
      return !!matchingCountryOption(select, code);
    }) || null;
  }

  function submitCountry(code, reason) {
    var normalized = normalizeCountry(code);
    var select = countrySelectFor(normalized);
    if (!select || !select.form) return false;

    var option = matchingCountryOption(select, normalized);
    if (!option) return false;

    select.value = option.value;
    if (reason === 'geoip') safeSet(window.sessionStorage, AUTO_KEY, normalized);
    if (reason === 'restore') safeSet(window.sessionStorage, RESTORE_KEY, normalized);
    select.form.submit();
    return true;
  }

  /* Capture manual country changes before the existing theme handler submits the form. */
  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-country-selector]');
    if (!select) return;
    var value = normalizeCountry(select.value);
    if (!value) return;
    safeSet(window.localStorage, MANUAL_KEY, value);
    safeSet(window.sessionStorage, AUTO_KEY, 'manual');
  }, true);

  function mountLocalization() {
    var hub = document.querySelector('[data-hv-localization-hub]');
    if (!hub) return null;

    var currentCountry = normalizeCountry(hub.getAttribute('data-current-country'));

    var headerSlot = hub.querySelector('[data-hv-localization-slot="header"]');
    var headerTarget = document.querySelector('.hv2-actions');
    if (headerSlot && headerTarget) headerTarget.insertBefore(headerSlot, headerTarget.firstChild);

    var mobileSlot = hub.querySelector('[data-hv-localization-slot="mobile"]');
    var mobileMenu = document.querySelector('.hv2-mobile-drawer__panel .hv2-mobile-menu');
    if (mobileSlot && mobileMenu) mobileMenu.insertAdjacentElement('afterend', mobileSlot);

    var footerSlot = hub.querySelector('[data-hv-localization-slot="footer"]');
    var footerContact = document.querySelector('.hv7-footer__brand .hv7-footer__contact');
    var footerBrand = document.querySelector('.hv7-footer__brand');
    if (footerSlot && footerContact) {
      footerContact.insertAdjacentElement('afterend', footerSlot);
    } else if (footerSlot && footerBrand) {
      footerBrand.appendChild(footerSlot);
    } else if (footerSlot) {
      var fallbackFooter = document.querySelector('footer');
      if (fallbackFooter) fallbackFooter.appendChild(footerSlot);
    }

    hub.remove();
    return currentCountry;
  }

  function detectAndApplyCountry(currentCountry) {
    if (!currentCountry) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var manualCountry = normalizeCountry(safeGet(window.localStorage, MANUAL_KEY));

    /* A visitor's explicit choice always wins over IP detection. */
    if (manualCountry) {
      if (manualCountry !== currentCountry && countrySelectFor(manualCountry)) {
        var restored = normalizeCountry(safeGet(window.sessionStorage, RESTORE_KEY));
        if (restored !== manualCountry) submitCountry(manualCountry, 'restore');
      }
      return;
    }

    var alreadyApplied = safeGet(window.sessionStorage, AUTO_KEY);
    if (alreadyApplied) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';

    var endpoint = root
      + 'browsing_context_suggestions.json'
      + '?country[enabled]=true'
      + '&country[exclude]=' + encodeURIComponent(currentCountry);

    safeSet(window.sessionStorage, AUTO_KEY, 'checking');

    fetch(endpoint, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Localization discovery failed');
        return response.json();
      })
      .then(function (payload) {
        var suggested = '';
        if (payload && payload.suggestions && payload.suggestions[0]
          && payload.suggestions[0].parts && payload.suggestions[0].parts.country) {
          suggested = payload.suggestions[0].parts.country.handle || '';
        }
        if (!suggested && payload && payload.detected_values && payload.detected_values.country) {
          suggested = payload.detected_values.country.handle || '';
        }

        suggested = normalizeCountry(suggested);
        if (!suggested || suggested === currentCountry) {
          safeSet(window.sessionStorage, AUTO_KEY, currentCountry);
          return;
        }

        if (!countrySelectFor(suggested)) {
          safeSet(window.sessionStorage, AUTO_KEY, 'unavailable:' + suggested);
          return;
        }

        submitCountry(suggested, 'geoip');
      })
      .catch(function () {
        safeSet(window.sessionStorage, AUTO_KEY, 'failed');
      });
  }

  function init() {
    mountLocalization();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
